import {useTheme, Text, Stack} from '@fluentui/react';
import {useUserContext} from 'authentication/UserContext';
import {useTranslation} from 'react-i18next';
import {
	getDashboardClassNames,
	MyRecentActivity,
} from './components/Common/BaseWorkBenchComponent';
import React, {useState} from 'react';
import VkoWorkbenchComponent from './components/VkoWorkbench/VkoWorkbenchComponent';
import {WorkbenchBaselineList} from './components/BedarfsWorkbench/WorkbenchBaselineList';
import {BedarfsWorkbenchSection} from './components/BedarfsWorkbench/BedarfsWorkbenchSection';
import {MyReviewItems} from './components/ApproverWorkbench/MyReviewItems';
import {DashboardPageVexPart} from './DashboardPageVexPart';

const DashboardPage = () => {
	const {t} = useTranslation('features/dashboard', {
		keyPrefix: 'DashboardPage',
	});
	const theme = useTheme();
	const classNames = getDashboardClassNames(theme);
	const {isVex, isVko, isApprover, isBedarfskoordinator} = useUserContext();

	type ItemCountType = number | undefined;
	const [approverReviewCount, setApproverReviewCount] =
		useState<ItemCountType>(undefined);
	const [activityItemCount, setActivityItemCount] =
		useState<ItemCountType>(undefined);
	const [baselineItemCount, setBaselineItemCount] =
		useState<ItemCountType>(undefined);
	const renderBedarfsWorkbenchLists = () => (
		<WorkbenchBaselineList
			halfHeight
			itemCountLoaded={(count: number) => setBaselineItemCount(count)}
		/>
	);

	return (
		<div style={{background: theme.palette.neutralLight}}>
			{isVko && <VkoWorkbenchComponent />}
			<DashboardPageVexPart />
			{isApprover && approverReviewCount !== 0 && (
				<Stack horizontalAlign='start' className={classNames.WorkbenchHeader}>
					<Text className={classNames.WorkbenchHeaderText}>
						{t('ApproverOveriewHeader')}
					</Text>
				</Stack>
			)}
			{isApprover && (
				<Stack
					horizontal
					horizontalAlign='start'
					styles={{root: {width: '100%'}}}
					grow={1}
				>
					<MyReviewItems
						halfHeight
						itemCountLoaded={(count: number) => setApproverReviewCount(count)}
					/>
				</Stack>
			)}
			{isBedarfskoordinator && (
				<BedarfsWorkbenchSection
					renderBedarfsWorkbenchLists={renderBedarfsWorkbenchLists}
					t={t}
				/>
			)}
			{isVex && activityItemCount !== 0 && (
				<MyRecentActivity
					itemCountLoaded={(count: number) => setActivityItemCount(count)}
				/>
			)}
		</div>
	);
};

export default DashboardPage;
